import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
	// -------------------------------------------------------------
	// Toggle Menu on click
	// -------------------------------------------------------------
	const menuToggle = document.querySelector(".menu-icon-container");

	const menu = document.querySelector("nav#main-nav");
	const menuCloseButton = menu.querySelector(".close-btn-container");

	function toggleMenu () {
		menu.classList.toggle("active");

		if (menu.classList.contains("active")) {
			document.getElementById("nav-overlay").classList.add("active");
		} else {
			document.getElementById("nav-overlay").classList.remove("active");
		}
	}

	document.addEventListener("click", (event) => {
		if (menu.classList.contains("active") && !menu.contains(event.target) && !menuToggle.contains(event.target)) {
			toggleMenu();
		}
	});

	if (menuToggle) {
		menuToggle.addEventListener("click", toggleMenu);
	}
	if (menuCloseButton) {
		menuCloseButton.addEventListener("click", toggleMenu);
	}

	// -------------------------------------------------------------
	// Toggle fade on menu scroll
	// -------------------------------------------------------------

	const menuContainer = menu.querySelector(".nav-container");
	const menuContent = document.querySelector(".menu-main-menu-container");

	function updateShadows () {

		const scrollTop = menuContent.scrollTop;
		const scrollHeight = menuContent.scrollHeight;
		const height = menuContainer.clientHeight;

		menuContainer.style.setProperty("--top-shadow", scrollTop > 0 ? "1" : "0");
		menuContainer.style.setProperty("--bottom-shadow", scrollTop < scrollHeight - height ? "1" : "0");

	}

	function checkVerticalOverflow (element) {
		return element.scrollHeight > element.clientHeight;
	}

	menuContent.addEventListener("scroll", updateShadows);
	updateShadows(); // Initialize on page load

	window.addEventListener("resize", updateShadows);

});